import { CommonModule } from "@angular/common";
import { Injector, NgModule } from "@angular/core";

import { defineCustomElements } from "@dffedb/util";


import { DffedbIframeComponent } from "./dffedb-iframe.component";

@NgModule({
    imports: [CommonModule, DffedbIframeComponent],
    exports: [DffedbIframeComponent],
    providers: []
})
export class DffedbIframeModule {
    constructor(injector: Injector) {
        defineCustomElements("dffedb-iframe", DffedbIframeComponent, { injector });
    }
}
